import styled from 'styled-components';

// 모달
// input modal
export const ModalBoxType1 = styled.div`
  width: 100%;
  max-width: 320px;
  background-color: #fff;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  box-sizing: border-box;
  border-radius: 16px;
  padding: 20px 12px 24px 12px;

  > h1 {
    box-sizing: border-box;
    padding: 0 8px;
    font-size: 18px;
    font-weight: 800;
    color: #333;
  }

  > p {
    padding: 0 8px;
    font-size: 14px;
    color: #999;
    margin-top: 4px;
  }

  ul.input-wrap {
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-top: 24px;

    > li {
      display: flex;
      flex-direction: column;
      gap: 8px;

      h2 {
        font-size: 15px;
        font-weight: 700;
        color: #333;
        display: flex;
        gap: 2px;

        > .img-box {
          width: 8px;
        }
      }
    }
  }

  > .btn-box {
    margin-top: 28px;
    display: flex;
    gap: 8px;
    box-sizing: border-box;
    padding: 0 8px;
  }

  &.full-screen {
    max-width: inherit;
    border-radius: inherit;
  }
`;
// confirm modal
export const ModalBoxType2 = styled.div`
  width: 100%;
  max-width: 320px;
  background-color: #fff;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  box-sizing: border-box;
  border-radius: 16px;
  padding: 88px 20px 24px 20px;

  p {
    font-size: 18px;
    color: #333;
    font-weight: 800;
    text-align: center;
    line-height: 1.4;
    word-break: keep-all;
  }

  .btn-box {
    margin-top: 55px;
    display: flex;
    gap: 8px;
  }
`;

// 로그인 및 회원가입 인풋
export const LoginInputWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;
export const LoginInputType = styled.div`
  width: 100%;
  box-sizing: border-box;
  padding: 12px;
  border-radius: 8px;
  background-color: #fafafa;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);

  h1 {
    font-size: 12px;
    color: #67717e;
    font-weight: 500;
    display: flex;
    gap: 2px;

    .img-box {
      width: 6px;
    }
  }

  div {
    margin-top: 8px;
    display: flex;
    align-items: center;
    gap: 8px;

    .right-box {
      display: flex;
      align-items: center;
      gap: 10px;
    }

    input {
      width: 100%;
      height: 24px;
      font-size: 16px;
      border: none;
      color: #111;
      background-color: #fafafa;
      &::placeholder {
        color: #ccc;
      }
      &:disabled {
        color: #999;
      }
    }

    button {
      width: 62px;
      min-width: 62px;
      height: 24px;
      border-radius: 4px;
      background-color: ${(props) => props.theme.mainColor1};
      color: #fff;
      font-size: 13px;
      display: flex;
      align-items: center;
      justify-content: center;
      &:disabled {
        background-color: #ccc;
        cursor: inherit;
      }
      &.retry {
        background-color: ${(props) => props.theme.mainColor2};
      }
    }

    .time-text {
      font-size: 15px;
      font-weight: 500;
      color: ${(props) => props.theme.mainColor1};
      &.timezero {
        color: #999;
      }
    }
  }
`;
export const LoginResultText = styled.p`
  color: #555555;
  font-size: 16px;
  font-weight: 500;
`;

// 검색 박스
export const SearchBox = styled.div`
  width: 100%;
  height: 48px;
  background-color: #4e5565;
  border-radius: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;

  > input {
    width: calc(100% - 56px);
    height: 100%;
    background-color: transparent;
    border: none;
    font-size: 14px;
    color: #fff;
    font-weight: 500;
    box-sizing: border-box;
    padding: 0 14px;
    &::placeholder {
      color: #ccc;
    }
  }

  > .img-box {
    width: 48px;
  }
`;

// 검색 결과 텍스트
export const SearchResultText = styled.p`
  margin-top: 12px;
  font-size: 16px;
  font-weight: 600;
  color: #191f28;
  line-height: 1.4;
`;

// 컨트롤 박스
export const CtrlBox = styled.div`
  > input {
    display: none;
  }

  > input:checked + label {
    background-color: #2869e2;
    &::after {
      right: 2px;
    }
  }

  > label {
    display: block;
    width: 32px;
    height: 19px;
    background-color: #adb3b7;
    border-radius: 15px;
    cursor: pointer;
    position: relative;
    &::after {
      content: '';
      display: block;
      width: 15px;
      height: 15px;
      border-radius: 50%;
      background: #fff;
      position: absolute;
      top: 50%;
      right: 15px;
      transform: translateY(-50%);
    }
  }
`;

// 방 리스트
export const RoomList = styled.li`
  width: 100%;
  box-sizing: border-box;
  padding: 16px;
  border-radius: 16px;
  box-shadow: ${(props) => props.theme.bsType1};
  background-color: #fff;
  display: flex;
  justify-content: space-between;

  .text-box {
    display: flex;
    flex-direction: column;
    gap: 20px;
    width: calc(100% - 60px);

    .title-box {
      display: flex;
      gap: 6px;

      .img-box {
        width: 16px;
        min-width: 16px;
        box-sizing: border-box;
        padding-top: 3.2px;
      }

      h1 {
        font-size: 16px;
        line-height: 1.4;
        font-weight: 700;
      }
    }

    .people-num-box {
      display: flex;
      gap: 8px;
      font-size: 12px;
      color: #666;
      font-weight: 500;

      .num {
        color: #000;
        font-weight: 500;
      }
    }
  }

  .entry-btn {
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 48px;
    border-radius: 8px;
    background-color: ${(props) => props.theme.mainColor1};
    color: #fff;
    font-size: 12px;
    &.history {
      background-color: ${(props) => props.theme.mainColor2};
    }
  }
`;

// 테이블 타입1
export const TableType1 = styled.div`
  overflow: auto;

  tr {
    th {
      height: 34px;
      font-size: 13px;
      font-weight: 700;
      color: #333;
      background: #fff;
      box-sizing: border-box;
      padding: 0 12px;
      white-space: nowrap;
      border-top: 2px solid #000;
      text-align: center;
    }

    td {
      height: 34px;
      font-size: 12px;
      font-weight: 500;
      color: #333;
      background: #fff;
      box-sizing: border-box;
      padding: 0 12px;
      white-space: nowrap;
      border-top: 1px solid #f0f0f0;
      text-align: center;
    }
  }
`;

// 페이지네이션
export const Pagenation = styled.div`
  margin-top: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;

  > button {
    width: 14px;
    &:disabled {
      opacity: 0;
      cursor: inherit;
    }
  }

  > ul {
    display: flex;
    gap: 4px;

    > li {
      width: 20px;
      height: 20px;
      border-radius: 50%;
      color: #555;
      font-size: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      &.active {
        background: ${(props) => props.theme.mainColor1};
        color: #fff;
        font-weight: 500;
      }
    }
  }
`;

// 입출차 카드 리스트
export const EntryAndExitCardListBox = styled.ul`
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
  overflow-y: auto;

  > li {
    box-sizing: border-box;
    padding: 12px;
    border-radius: 8px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    &.wait {
      background-color: #66666633;
    }
    &.basic-member.active {
      border-color: ${(props) => props.theme.subColor3};
    }
    &.fix-member.active {
      border-color: ${(props) => props.theme.mainColor1};
    }
    &.basic-member.my {
      border-color: ${(props) => props.theme.subColor3};
    }
    &.fix-member.my {
      border-color: ${(props) => props.theme.mainColor1};
    }
    &.basic-member {
      .left-box {
        .title-box {
          h2 {
            color: ${(props) => props.theme.subColor3};
          }
        }
      }
    }
    &.fix-member {
      .left-box {
        .title-box {
          h2 {
            color: ${(props) => props.theme.mainColor1};
          }
        }
      }
    }

    .left-box {
      display: flex;
      align-items: center;
      gap: 8px;
      .title-box {
        display: flex;
        flex-direction: column;
        gap: 4px;

        h1 {
          font-size: 13px;
          color: #666;
          word-break: break-all;
          font-weight: 700;
        }

        h2 {
          font-size: 14px;
          font-weight: 500;
          color: ${(props) => props.theme.mainColor1};
          word-break: break-all;
        }

        p {
          font-size: 14px;
          color: #4e5565;
          line-height: 1.4;
          word-break: break-all;
        }
      }
    }

    .right-box {
      display: flex;
      align-items: center;
      gap: 12px;

      .work-num-box {
        display: flex;
        gap: 8px;

        > li {
          display: flex;
          flex-direction: column;
          text-align: center;
          gap: 6px;

          > h4 {
            font-size: 13px;
            color: #666;
            white-space: nowrap;
          }

          > .num {
            font-size: 14px;
            color: #4e5565;
            font-weight: 500;
            white-space: nowrap;
          }
        }
      }
    }

    .add-box {
      position: relative;

      .img-box {
        width: 20px;
      }

      .add-btn-box {
        position: absolute;
        width: 84px;
        top: 50%;
        right: 100%;
        transform: translateY(-50%);
        background-color: #fff;
        border-radius: 4px;
        box-shadow: ${(props) => props.theme.bsType1};
        over-flow: hidden;

        > button {
          width: 100%;
          box-sizing: border-box;
          padding: 10px 0;
          font-size: 12px;
          color: #555;
          text-align: center;
        }
      }
    }
  }
`;

// 버튼1 타입
// height: 56px | font-size: 18px
export const Btn1Type = styled.button`
  width: 100%;
  height: 56px;
  box-sizing: border-box;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  font-weight: 500;
`;
// color: #fff | background-color: mainColor1
export const Btn1Type1 = styled(Btn1Type)`
  color: #fff;
  background-color: ${(props) => props.theme.mainColor1};
`;
// color: #555 | background-color: #fff | border: #555
export const Btn1Type2 = styled(Btn1Type)`
  color: #555;
  background-color: #fff;
  border: 1px solid #555;
`;
// color: #fff | background-color: mainColor2
export const Btn1Type3 = styled(Btn1Type)`
  color: #fff;
  background-color: ${(props) => props.theme.mainColor2};
`;
// color: #fff | background-color: mainColor3
export const Btn1Type4 = styled(Btn1Type)`
  color: #fff;
  background-color: ${(props) => props.theme.mainColor3};
`;
// color: #fff | background-color: #1A55C6
export const Btn1Type5 = styled(Btn1Type)`
  color: #fff;
  background-color: #1a55c6;
`;
// color: #fff | background-color: #D02F2F
export const Btn1Type6 = styled(Btn1Type)`
  color: #fff;
  background-color: #d02f2f;
`;

// 버튼2 타입
// width: 100% | height: 48px | font-size: 18px
export const Btn2Type = styled.button`
  width: 100%;
  height: 48px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-weight: 500;
`;
// color: #fff | background-color: mainColor1
export const Btn2Type1 = styled(Btn2Type)`
  color: #fff;
  background-color: ${(props) => props.theme.mainColor1};
`;
// color: #666 | background-color: #eee
export const Btn2Type2 = styled(Btn2Type)`
  color: #666;
  background-color: #eee;
`;

// 버튼3 타입
// width: 64px | height: 30px | font-size: 12px
export const Btn3Type = styled.button`
  width: 64px;
  height: 30px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 400;
`;
// color: #fff | background-color: mainColor1
export const Btn3Type1 = styled(Btn3Type)`
  color: #fff;
  background-color: ${(props) => props.theme.mainColor1};
`;
// color: #fff | background-color: mainColor2
export const Btn3Type2 = styled(Btn3Type)`
  color: #fff;
  background-color: ${(props) => props.theme.mainColor2};
`;
// color: #fff | background-color: mainColor3
export const Btn3Type3 = styled(Btn3Type)`
  color: #fff;
  background-color: ${(props) => props.theme.mainColor3};
`;

// 버튼4 타입
// width: 64px | height: 30px | font-size: 12px
export const Btn4Type = styled.button`
  width: 100%;
  height: 48px;
  border-radius: 8px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  font-weight: 500;
`;
// color: #fff | background-color: mainColor1
export const Btn4Type1 = styled(Btn4Type)`
  color: #fff;
  background-color: ${(props) => props.theme.mainColor1};
`;
// color: mainColor1 | background-color: #fff | border: mainColor1
export const Btn4Type2 = styled(Btn4Type)`
  color: ${(props) => props.theme.mainColor1};
  background-color: #fff;
  border: 1px solid ${(props) => props.theme.mainColor1};
`;

// 버튼5 타입
// width: 36px | height: 36px | border-radius: 50%
export const Btn5Type = styled.button`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  &:disabled {
    cursor: inherit;
    background-color: #bbb;
  }

  > .img-box {
    width: 20px;
  }
`;
// background-color: mainColor1
export const Btn5Type1 = styled(Btn5Type)`
  background-color: #888;
  &.on {
    background-color: ${(props) => props.theme.mainColor1};
  }
`;
// background-color: mainColor2
export const Btn5Type2 = styled(Btn5Type)`
  background-color: ${(props) => props.theme.mainColor2};
`;
// background-color: mainColor3
export const Btn5Type3 = styled(Btn5Type)`
  background-color: ${(props) => props.theme.mainColor3};
`;
// background-color: #D65757
export const Btn5Type4 = styled(Btn5Type)`
  background-color: #d65757;
`;

// 버튼6 타입
// width: 60px | height: 48px | font-size: 13px
export const Btn6Type = styled.button`
  width: 68px;
  height: 48px;
  border-radius: 8px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
`;
// background-color: mainColor3 | color: #fff
export const Btn6Type1 = styled(Btn6Type)`
  background-color: ${(props) => props.theme.mainColor3};
  color: #fff;
  &:disabled {
    background-color: #bbb;
    cursor: inherit;
  }
`;

// 텍스트 인풋 타입1
// height: 48px | font-size: 14px
export const TextInputType1 = styled.input`
  background-color: #fff;
  display: block;
  width: 100%;
  height: 48px;
  border-radius: 8px;
  border: 1px solid ${(props) => props.theme.inputBorderColor};
  box-sizing: border-box;
  padding: 0 16px;
  font-size: 14px;
  color: ${(props) => props.theme.inputColor};
  &::placeholder {
    color: ${(props) => props.theme.inputPlaceholderColor};
  }
  &:disabled {
    background-color: #f3f3f3;
  }
`;
// height: 36px | font-size: 12px
export const TextInputType1mini = styled(TextInputType1)`
  height: 36px;
  font-size: 12px;
`;

// 텍스트 인풋 타입1(중복확인 버튼 추가)
export const TextInputType1CheckBtnWrap = styled.div`
  position: relative;
  input {
    padding-right: 80px;
  }
  button {
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    width: 62px;
    min-width: 62px;
    height: 24px;
    border-radius: 4px;
    background-color: ${(props) => props.theme.mainColor1};
    color: #fff;
    font-size: 13px;
    display: flex;
    align-items: center;
    justify-content: center;
    &:disabled {
      background-color: #ccc;
      cursor: inherit;
    }
    &.retry {
      background-color: ${(props) => props.theme.mainColor2};
    }
  }
`;

// 텍스트 영역 타입1
// height: 110px | font-size: 14px
export const TextAreaType1 = styled.textarea`
  background-color: #fff;
  display: block;
  width: 100%;
  height: 110px;
  border-radius: 8px;
  border: 1px solid ${(props) => props.theme.inputBorderColor};
  box-sizing: border-box;
  padding: 12px 16px;
  font-size: 14px;
  color: ${(props) => props.theme.inputColor};
  &::placeholder {
    color: ${(props) => props.theme.inputPlaceholderColor};
  }
`;

// 셀렉트 타입1
// height: 48px | font-size: 14px
export const SelectType1 = styled.div`
  width: 100%;
  height: 48px;
  position: relative;

  > select {
    background-color: #fff;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 8px;
    border: 1px solid ${(props) => props.theme.inputBorderColor};
    box-sizing: border-box;
    padding: 0 16px;
    font-size: 14px;
    color: ${(props) => props.theme.inputPlaceholderColor};
    &.selected {
      color: ${(props) => props.theme.inputColor};
    }
    &:disabled {
      background-color: #f3f3f3;
    }
  }

  > .img-box {
    width: 22px;
    right: 8px;
    top: 50%;
    transform: translateY(-50%);
    position: absolute;
    pointer-events: none;
  }
`;

const CS = {
  ModalBoxType1,
  ModalBoxType2,
  LoginInputWrap,
  LoginInputType,
  LoginResultText,
  SearchBox,
  SearchResultText,
  CtrlBox,
  RoomList,
  TableType1,
  Pagenation,
  EntryAndExitCardListBox,
  Btn1Type1,
  Btn1Type2,
  Btn1Type3,
  Btn1Type4,
  Btn1Type5,
  Btn1Type6,
  Btn2Type1,
  Btn2Type2,
  Btn3Type1,
  Btn3Type2,
  Btn3Type3,
  Btn4Type1,
  Btn4Type2,
  Btn5Type1,
  Btn5Type2,
  Btn5Type3,
  Btn5Type4,
  Btn6Type1,
  TextInputType1,
  TextInputType1mini,
  TextInputType1CheckBtnWrap,
  TextAreaType1,
  SelectType1,
};

export default CS;
